import moment from 'moment';
import React, { useEffect, useRef, useState } from 'react';
import { DATE_FORMAT, PAGE_SIZE } from '../../_common/constant';
import Icon from '../../components/icons';
import { useLocation, useParams } from 'react-router-dom';
import { useAssetsApi } from '../../store/api/hooks/assetsApiHook';
import { AgGridReact } from 'ag-grid-react';
import { useDialog } from '../../store/api/hooks/dialogHook';
import { useAppLoader } from '../../_common/pageLoader/appLoaderHook';
import Pagination from '../../components/pagination';
import Search from '../../components/search';
import Button from '../../components/elements/button';
import Drawer from '../../components/Drawer';

import toast from 'react-hot-toast';
import { downloadExcel, getPermissionInfo, showLocalDate } from '../../_common/functions';
import CreateWarrenty from '../Assets/_components/createWarrenty';
import Layout from '../../components/layout';
import Header from '../../components/header';
import SelectBox from '../../components/elements/form/selectBox';
import { Controller, useForm } from 'react-hook-form';
import Loader from '../../components/loader';
import Currency from '../../components/currency';
import { useUserSelector } from '../../store/selectors/userSelector';

const WarrantyList: React.FC = () => {
    const location = useLocation();
    const loggedinuser: any = useUserSelector();
    const params: any = useParams();
    const assetsAPI = useAssetsApi();
    const [columnDefs, setColumnDefs] = useState<any[] | null>(null);
    const [gridApi, setGridApi] = useState<any>(null);
    const [totalRecords, setTotalRecords] = useState<number>(0);
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [searchParam, setSearchParam] = useState<string>('');
    const { confirm } = useDialog();
    const [gridColumnApi, setGridColumnApi] = useState<any>(null);
    const [attachments, setAttachment] = useState<[]>([]);
    const { showLoader, hideLoader } = useAppLoader();
    const addWarrentyDrawerRef: any = React.createRef<HTMLButtonElement>();
    const addNewWarrentyRef: any = useRef();
    const [filterValue, setFilterValue] = useState<any>(null);
    const [warranty, setWarranty] = useState<any>(null);
    const onGridReady = (params: any) => {
        setGridApi(params.api);
        setGridColumnApi(params.columnApi);
    };
    const { control, register, handleSubmit, setValue, watch, getValues, formState: { errors }, reset } = useForm<any>({
        defaultValues: {
            warrantyTermsID: "30",
        }
    });
    const onRowClicked = (event: any) => {
        if (!event.event.target.closest('input[type="checkbox"]')) {
            event.node.setSelected(false); // Unselect row if it's clicked, not by checkbox
        }
    };

    const handleActionChange = (e: any, params: any) => {
        const action = e.target.value;
        const rowData = params.data;

        switch (action) {
            case "edit":
                // Implement edit action
                setWarranty(rowData);
                addWarrentyDrawerRef.current.open();
                console.log("Edit action for row: ", rowData);
                break;
            case "delete":
                // Implement delete action

                break;
            case "duplicate":
                console.log("Duplicate action for row: ", rowData);
                break;
            case "move-asset":
                // Implement move asset action
                console.log("Move Asset action for row: ", rowData);
                break;

            case "schedule-maintenance":
                // Implement schedule maintenance action
                console.log("Schedule Maintenance action for row: ", rowData);
                break;
            default:
                console.log("Unknown action: ", action);
                break;
        }
        e.target.selectedIndex = -1;
    };
    const getSelectedRows = () => {
        const selectedNodes = gridApi?.getSelectedNodes();
        const selectedData = selectedNodes.map((node: any) => node.data);
        return selectedData;
    };
    const onBulkExportCsv = async () => {
        // Check permission before performing export action
        if (!getPermissionInfo(location.pathname, "Export", loggedinuser)) {
            toast.error(`You don't have Export permission`);
            return;
        }

        const selectedData = getSelectedRows();

        if (selectedData.length == 0) {
            toast.error("Nothing is selected")
        } else {
            console.log("selectedData", selectedData)
            const warrantyIDs = selectedData.map((asset: any) => asset.warrantyID).join(',');

            //   const payload = { assetIDs: assetIDs };
            const payload = { warrantyIDs: warrantyIDs };
            assetsAPI.WarrantyExportToXLS(
                payload,
                (resp: any) => { downloadExcel(resp, 'WarrantyXls') },
                (error: any) => {
                    console.log("error =>", error);
                    toast.error(error);
                }
            );
        }

    };

    useEffect(() => {
        setColumnDefs([
            { headerCheckboxSelection: true, checkboxSelection: true, width: 50, headerClass: 'bg-[#f0f0f0]' },
            {
                headerName: "Assets Name",
                minWidth: 250,
                flex: 1,
                field: "assetName",
                sortable: true,
                headerClass: "bg-[#f0f0f0]",
                cellRenderer: (data: any) => {
                    return (
                        <p title={`${data?.data?.assetName
                            ? data?.data?.assetName
                            : "-"}`} className="hover:text-primary text-ellipsis overflow-hidden">
                            {data?.data?.assetName
                                ? data?.data?.assetName
                                : "-"}
                        </p>
                    );
                },
            },
            {
                headerName: "Vendor Doc No",
                width: 250,
                field: "vendorDocNo",
                headerClass: "bg-[#f0f0f0]",
                cellRenderer: (data: any) => {
                    return (
                        <p className="hover:text-primary">
                            {data?.data?.vendorDocNo
                                ? data?.data?.vendorDocNo
                                : "-"}
                        </p>
                    );
                },
            },
            {
                headerName: "Vendor",
                field: "vendorName",
                headerClass: "bg-[#f0f0f0] ",
                width: 250,

                cellRenderer: (data: any) => {
                    return (
                        <p title={`${data?.data?.vendorName
                            ? data?.data?.vendorName
                            : "-"}`} className="hover:text-primary text-ellipsis overflow-hidden">
                            {data?.data?.vendorName
                                ? data?.data?.vendorName
                                : "-"}
                        </p>
                    );
                },
            },

            {
                headerName: "Start Date",
                width: 140,
                sortable: true,
                field: "warrantyStartDate",
                headerClass: "bg-[#f0f0f0]",
                cellRenderer: (data: any) => {
                    return (
                        <p className="hover:text-primary">
                            {data?.data?.warrantyStartDate
                                ? showLocalDate(data?.data?.warrantyStartDate)
                                : "-"}
                        </p>
                    );
                },
            },
            {
                headerName: "End Date",
                width: 140,
                sortable: true,
                field: "warrantyEndDate",
                headerClass: "bg-[#f0f0f0]",
                cellRenderer: (data: any) => {
                    return (
                        <p className="hover:text-primary">
                            {data?.data?.warrantyEndDate
                                ? showLocalDate(data?.data?.warrantyEndDate)
                                : "-"}
                        </p>
                    );
                },
            },
            {
                headerName: "Days Until Expiry",
                width: 150,
                field: "daysUntillExpiry",
                sortable: true,
                headerClass: "bg-[#f0f0f0]",
                cellRenderer: (data: any) => {
                    const daysUntilExpiry = data?.data?.daysUntillExpiry;

                    let displayText;
                    if (daysUntilExpiry !== undefined && daysUntilExpiry !== "-") {
                        if (parseInt(daysUntilExpiry) < 0) {
                            //  displayText = `Expired ${Math.abs(parseInt(daysUntilExpiry))} days ago`;

                            displayText = `Expired`;
                        } else {
                            displayText = daysUntilExpiry + ' days';
                        }
                    } else {
                        displayText = "-";
                    }
                    return (
                        <p className="hover:text-primary">

                            {displayText}
                        </p>
                    );
                },
            },
            {
                headerName: "Warranty Terms",
                field: "warrantyTermsName",
                headerClass: "bg-[#f0f0f0] text-center",
                width: 150,
                cellRenderer: (data: any) => {
                    return (
                        <p title={`${data?.data?.warrantyTermsName
                            ? data?.data?.warrantyTermsName
                            : "-"}`} className="hover:text-primary text-ellipsis overflow-hidden">
                            {data?.data?.warrantyTermsName
                                ? data?.data?.warrantyTermsName
                                : "-"}
                        </p>
                    );
                },
            },
            {
                headerName: "Cost",
                field: "warrantyAMCCost",
                sortable: true,
                headerClass: "bg-[#f0f0f0] ag-right-aligned-header",
                width: 130,
                cellClass: 'ag-right-aligned-cell',
                cellRenderer: (data: any) => {
                    return (
                        <p className="hover:text-primary">
                            <Currency currency="USD" value={data?.data?.warrantyAMCCost} />
                        </p>
                    );
                },
            },
            {
                headerName: "Action",
                field: "actions",
                headerClass: "bg-[#f0f0f0] text-center",
                pinned: 'right',
                width: 90,
                cellRenderer: (params: any) => {
                    return (
                        <div className='relative h-full w-full flex items-center justify-center'>
                            <Icon name='threedote' size={1.25} className='text-[#000000]' onClick={(e: any) => {
                                e.stopPropagation();
                                e.preventDefault();
                                const dropdown: any = document.querySelector('.action-dropdown');
                                if (dropdown) {
                                    dropdown.focus();
                                }
                                return false;
                            }} />
                            <select
                                onChange={(e) => {

                                    handleActionChange(e, params);
                                    //e.target.value = '';
                                }}
                                onFocus={(e) => {
                                    e.target.selectedIndex = -1;
                                }
                                }
                                className="action-dropdown"
                                value={''}
                                style={{
                                    position: "absolute",
                                    top: 0,
                                    left: 0,
                                    width: "100%",
                                    height: "100%",
                                    opacity: 0,
                                    cursor: "pointer",
                                }}
                            >
                                <option value="edit">Update Warranty</option>

                            </select>
                        </div>
                    );
                },
            }
        ]);
    }, [params]);
    const WatchWarrantyTermsID = watch('warrantyTermsID');
    const GetWarrantyList = () => {
        let payload: any = {
            pageSize: PAGE_SIZE,
            pageNumber: currentPage,
            searchParam: searchParam,
            //  assetID:  params.id
        };
        if (WatchWarrantyTermsID && WatchWarrantyTermsID !== "0") {
            const currentDate = new Date(); // Get current date
            // console.log(currentDate);
            //  console.log("WatchWarrantyTermsID",WatchWarrantyTermsID);
            currentDate.setDate(currentDate.getDate() + Number(WatchWarrantyTermsID));
            //console.log("New Date:", currentDate);
            payload['EndDate'] = currentDate;
        }

        assetsAPI.GetWarrantyList(payload, (data: any) => {
            setAttachment(data.warrantyList ? data.warrantyList : []);
            setTotalRecords(data.totalRecord);
        }, (error: any) => { });
    };

    useEffect(() => {
        if (params.id) {
            GetWarrantyList();
        }

    }, [params]);
    useEffect(() => {

        GetWarrantyList();

    }, [currentPage, searchParam]);
    useEffect(() => {

        GetWarrantyList();

    }, [WatchWarrantyTermsID]);



    return (


        <Layout>
            <Header title='Warranty List'>
                <Header.Right>

                    <Drawer _ref={addWarrentyDrawerRef} onClose={() => {
                        setWarranty(null);
                        GetWarrantyList();
                        addNewWarrentyRef?.current?.reset()

                    }} outsideClose={false}>
                        <Drawer.Button>
                            {/* <Button >Create New Warranty</Button> */}
                        </Drawer.Button>
                        {/* <Drawer.Content title={warranty ? 'Edit Warranty' : 'Create New Warranty'} className='!w-[39.563rem]'> */}
                        <Drawer.Content title='Create New Warranty' className='!w-[39.563rem]'>
                            <CreateWarrenty fromList={true} _ref={addNewWarrentyRef} editData={warranty} onCreate={() => {
                                GetWarrantyList();
                                addWarrentyDrawerRef.current.close();

                            }} onCancel={() => {
                                GetWarrantyList();
                                addWarrentyDrawerRef.current.close();

                            }} />
                        </Drawer.Content>
                    </Drawer>


                </Header.Right>
            </Header>
            <div className='flex items-center justify-between pl-5 pr-3 border-b border-gray-200 h-[3.75rem]'>
                <Pagination
                    perPage={PAGE_SIZE}
                    totalRecords={totalRecords}
                    onPageChange={setCurrentPage}
                    currentPage={currentPage}
                />
                <div className='flex gap-2 items-center justify-center'>

                    <Controller
                        name='warrantyTermsID'
                        control={control}
                        rules={{ required: 'Warranty Terms is required' }}
                        render={({ field: { value, onChange } }) => (


                            <select
                                onChange={(e) => {
                                    onChange(e.target.value); // Update form state with the selected value
                                }}
                                onFocus={(e) => {
                                    e.target.selectedIndex = -1;
                                }}
                                className="action-dropdown"
                                value={value || ''}
                                style={{
                                    width: "100%",
                                    height: "36px",
                                    border: "1px solid #E5E7EB",
                                    borderRadius: "0.375rem",
                                    padding: "0.5rem",
                                    backgroundColor: "#FFFFFF",
                                    lineHeight: "1",
                                    cursor: "pointer",
                                }}
                            >
                                <option value="0">All</option>
                                <option value="30">Next 30 days</option>
                                <option value="90">Next 3 months</option>
                                <option value="180">Next 6 months</option>
                                <option value="365">Next 1 year</option>

                            </select>

                        )}
                    />
                    <Button disabled={!getPermissionInfo(location.pathname, "Export", loggedinuser)} theme='light' onClick={() => {
                        onBulkExportCsv()
                    }} >Export</Button>
                    <Search onSearch={setSearchParam} placeholder='Search by name or doc no' />
                </div>

            </div>


            <div className="ag-theme-alpine mx-4  h-1/2" style={{ height: 400 }}>
                <AgGridReact
                    columnDefs={columnDefs} // Pass columnDefs
                    rowData={attachments || []} // Pass rowData
                    pagination={false}
                    rowSelection="multiple"
                    onGridReady={onGridReady}
                    domLayout="autoHeight"
                    onRowClicked={onRowClicked}
                    loadingOverlayComponent={Loader}
                    noRowsOverlayComponent={() => (
                        <div className="flex items-center justify-center h-full">
                            <div className="text-center text-gray-500">
                                <div className="text-lg font-medium">No Data Found</div>
                            </div>
                        </div>
                    )}
                />
            </div>


        </Layout>
    );
};

export default WarrantyList;